import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreditTemplate = _resolveComponent("CreditTemplate")!

  return (_openBlock(), _createBlock(_component_CreditTemplate, { i18n: _ctx.i18n }, null, 8, ["i18n"]))
}